import type { GgxTourDefinition } from './tour-types';

export const START_02: GgxTourDefinition = {
    key: "[START-02] Knowing what to do when you're stuck",
    route: '/home',
    estimatedMinutes: 2,
    intro: {
        headline: 'Stuck? Help is one click away',
        subtitle:
            'A quick look at where to get help in GGX: chat with the team, raise a ticket, ' +
            'book a session or look it up in the documentation.',
    },
    outro: {
        title: 'You know where to find help.',
        subtitle:
            'Whenever something is unclear, the help icon is one click away on every page. ' +
            'The Learning Hub keeps this tour if you ever want to watch it again.',
        learned: [
            'The **help icon** opens chat, tickets, sessions and documentation.',
            '**Chat** is the fastest way to reach the team.',
            'The **Learning Hub** has tours and webinars for every stage.',
        ],
    },
    chapters: [
        {
            name: 'Getting help',
            blurb: 'Where support lives in GGX',
            icon: 'compass',
            steps: [2],
        },
    ],
    steps: [
        {
            title: "Need support? You're one click away",
            whatHappens: 'the tour wraps up with a short summary.',
            icon: 'compass',
            description:
                'Click the <strong>?</strong> help icon to chat with us instantly, raise a ' +
                'ticket, book a session or explore the documentation. This short video shows ' +
                'how support works across GGX. Watch it, then click Continue.',
            video: {
                src: 'https://genguardx.ai/tours/start-02-getting-help.mp4',
                title: "Knowing what to do when you're stuck",
            },
            draftCopy: true,
        },
    ],
};
